import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Master/locations`;

export const getAllLocations = async () => {
  const response = await axios.get(API_URL, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return response.data;
};
